import React from "react";
import styled from "styled-components";
import { useHistory } from "react-router";
import { IoWarningOutline as WarningIcon } from "react-icons/io5";

import Button from "../../components/Button-v2";
import Navbar from "../../components/Navbar";

const PermissionDeniedComponent = () => {
  const history = useHistory();
  return (
    <Body>
      <Navbar hideNavigation />
      <ContentWrapper>
        <TitleWrapper>
          <IconWrapper>
            <WarningIcon />
          </IconWrapper>
          <MessageWrapper>
            Você não possui permissão para acessar esta página.
          </MessageWrapper>
        </TitleWrapper>
        <ButtonWrapper>
          <Button
            width="100%"
            height="32px"
            onClick={() => history.push("/home")}
          >
            Voltar a tela inicial
          </Button>
        </ButtonWrapper>
      </ContentWrapper>
    </Body>
  );
};

export default PermissionDeniedComponent;

const Body = styled.div`
  width: 100vw;
  height: 100vh;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
`;

const ContentWrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
`;

const TitleWrapper = styled.div`
  display: flex;
  flex-direction: column;
`;

const IconWrapper = styled.div`
  display: flex;
  justify-content: center;

  svg {
    font-size: 120px;
  }
`;

const MessageWrapper = styled.div`
  font-family: Roboto;
  font-size: 1.8rem;
  text-align: center;
  margin-top: 2rem;
`;

const ButtonWrapper = styled.div`
  width: 300px;
  margin-top: 5rem;
`;
